import { Renderer } from "leaflet";
import * as React from "react";
import { useState, useEffect } from "react";
import { FxmsData } from "./../datas/FxData";
import { FxRenderer } from "./../datas/FxRenderer";
import { FxInfoList } from "./FxInfoList";

/**
 * 알람, 공지사항을 알린다.
 * 개발자 : 최선하.
 * 개발년월 : 2022.11.
 * @returns
 */
export const FxInfoNoticeList = (props) => {
  const { title, onClick } = props;
  const [inform, setInform] = useState(null);

  useEffect(() => {
    const list = getNoticeData();
  }, []);

  async function getNoticeData() {
    const uri = "fxms/select_board";
    const para = { limit: 3 };
    const ret = [];
    const res = await FxmsData.GET(uri, para);
    const inform = [];
    let index = 0;
    for (let data of res.data) {
      inform.push({
        id: data.boardNo,
        title: data.boardTitle,
        date: FxRenderer.renderDate(data.postStrtDate),
        data: data,
      });
    }
    setInform(inform);
  }

  return (
    <FxInfoList
      title="공지사항"
      inform={inform}
      onClick={props.onClick}
      moreOpId="ui-board"
      itemOpId="ui-board-show"
    ></FxInfoList>
  );
};
